import {
  MIN_PASS_ATTEMPTS,
  MIN_RUSH_ATTEMPTS,
  MIN_RECEPTIONS,
} from "../constants/nflSimilarity";
import { seasonInScope, US_MAJOR_SCOPE, parseStatNumber } from "./nflLeagueScope";

export const NFL_SIMILAR_ROLES = new Set(["passing", "rushing", "receiving"]);

const ROLE_COVERAGE_GATE = {
  passing: (season) => parseStatNumber(season?.att) >= MIN_PASS_ATTEMPTS,
  rushing: (season) => parseStatNumber(season?.att) >= MIN_RUSH_ATTEMPTS,
  receiving: (season) => parseStatNumber(season?.rec) >= MIN_RECEPTIONS,
};

export const eligibleNflSimilarSeasons = (player, role) => {
  if (!NFL_SIMILAR_ROLES.has(role)) return [];
  const seasons = player?.stats?.[role]?.seasons || {};
  const gate = ROLE_COVERAGE_GATE[role];
  return Object.entries(seasons)
    .filter(([, season]) =>
      seasonInScope(season?.season, season?.team, US_MAJOR_SCOPE) &&
      gate(season)
    )
    .map(([year]) => String(year))
    .sort((a, b) => Number(b) - Number(a));
};

export const parseNflSimilarSearch = (searchParams) => {
  const season = searchParams?.get("season") || undefined;
  const roleParam = searchParams?.get("role");
  const role = NFL_SIMILAR_ROLES.has(roleParam) ? roleParam : undefined;
  return { season, role };
};

export const serializeNflSimilarSearch = ({ season, role } = {}) => {
  const searchParams = new URLSearchParams();
  if (season) searchParams.set("season", season);
  if (NFL_SIMILAR_ROLES.has(role)) searchParams.set("role", role);
  return searchParams;
};
